import React from "react";
import "./MyTechProfileActionBar.css";

const MyTechProfileActionBar = ({ onPublish, previewUrl }) => {
  return (
    <div className="mytechprofile_actionbar">
      <button
        className="action_button preview_button"
        onClick={() => window.open(previewUrl, "_blank")}
      >
        View Preview
      </button>

      <button className="action_button publish_button" onClick={onPublish}>
        Publish Changes
        <span className="shimmer"></span>
      </button>
    </div>
  );
};

export default MyTechProfileActionBar;
